// src/components/ui/Select.tsx
import {
  Select as MUISelect,
  SelectProps,
  FormControl,
  InputLabel,
  MenuItem,
} from '@mui/material';
import React from 'react';

export interface Option {
  label: string;
  value: string;
}

interface Props extends Omit<SelectProps, 'children'> {
  label: string;
  options: Option[];
}

const Select: React.FC<Props> = ({ label, options, ...rest }) => {
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>{label}</InputLabel>
      <MUISelect label={label} {...rest}>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </MUISelect>
    </FormControl>
  );
};

export default Select;
